const objections = [
  {
    q: "\u201CFilings are 45 days late.\u201D",
    a: "They are, and it barely matters. These investors build over months and hold for quarters; a disclosed buy is usually still alive. Then we correct the lag itself, week after week.",
  },
  {
    q: "\u201CIf it's so obvious, it's priced in.\u201D",
    a: "The edge is buried in tedium: 10,000+ filers, unreadable at scale. Almost nobody does the work, and it regenerates every quarter. The infrastructure is the product.",
  },
  {
    q: "\u201CIs this insider trading?\u201D",
    a: "No. The opposite. Everything we read is public and mandatory. We don't know anything the market can't know. We just read it earlier, and more carefully.",
  },
];

export default function Objections() {
  return (
    <section id="objections" className="fp-section !py-16">
      <p className="fp-eyebrow mb-8">The three objections, answered</p>
      <div className="grid md:grid-cols-3 gap-6">
        {objections.map((o, i) => (
          <div key={i} data-testid={`objection-${i}`}>
            <p className="text-base text-[#5A6272] italic mb-3">{o.q}</p>
            <p className="text-sm text-[#E8EBF0] leading-relaxed">{o.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
